// client/src/pages/secure/ComplianceHubPage.js
import React, { useState, useEffect } from 'react';
import { useApiClient } from '../../hooks/useApiClient';
import TransactionComplianceChecklist from '../../components/secure/TransactionComplianceChecklist';

const ComplianceHubPage = () => {
    const [transactions, setTransactions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedTransactionId, setSelectedTransactionId] = useState(null);
    const apiClient = useApiClient();

    useEffect(() => {
        apiClient.get('/api/transactions')
            .then(data => setTransactions(data))
            .catch(err => setError(err.message || 'Failed to fetch transactions.'))
            .finally(() => setIsLoading(false));
    }, [apiClient]);

    const handleSelectTransaction = (id) => {
        setSelectedTransactionId(currentId => (currentId === id ? null : id));
    };

    return (
        <div className="space-y-8">
            <div>
                <h1 className="text-3xl font-bold text-slate-800">Compliance Hub</h1>
                <p className="text-slate-600 mt-1">Select a transaction to review its compliance status.</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
                <h2 className="text-xl font-bold text-slate-800 mb-4">Transactions</h2>
                {isLoading && <p>Loading transactions...</p>}
                {error && <p className="text-red-500">{error}</p>}
                {!isLoading && !error && (
                    <ul className="space-y-2">
                        {transactions.map(t => (
                            <li key={t.transaction_id} className="border rounded-md">
                                <button 
                                    onClick={() => handleSelectTransaction(t.transaction_id)}
                                    className="w-full text-left p-4 hover:bg-slate-50"
                                >
                                    <div className="flex justify-between items-center">
                                        <span className="font-semibold text-indigo-700">{t.street_address}</span>
                                        <span className="text-sm text-slate-500">Agent: {t.agent_name || 'N/A'}</span>
                                    </div>
                                </button>
                                {selectedTransactionId === t.transaction_id && (
                                    <div className="p-4 border-t bg-slate-50">
                                        <TransactionComplianceChecklist transactionId={t.transaction_id} />
                                    </div>
                                )}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default ComplianceHubPage;